import { useTranslate } from '@repo/shared/hooks'
import { Badge, Col, Icon, Typography } from '@repo/ui/components'
import { cn } from '@repo/ui/lib'

export const SquareTokenRewardSection = () => {
  const { t, tRich } = useTranslate()

  const levels = [
    {
      name: 'bronze',
      rangeFrom: '0',
      rangeTo: '1,999',
      multiplier: '1.00',
      color: 'bg-[#E39582]',
    },
    {
      name: 'silver',
      rangeFrom: '2,000',
      rangeTo: '9,999',
      multiplier: '1.05',
      color: 'bg-[#D8DDE6]',
    },
    {
      name: 'gold',
      rangeFrom: '10,000',
      rangeTo: '49,999',
      multiplier: '1.10',
      color: 'bg-[#F0C777]',
    },
    {
      name: 'diamond',
      rangeFrom: '50,000',
      rangeTo: '199,999',
      multiplier: '1.15',
      color: 'bg-[#99EEFF]',
    },
    {
      name: 'expert',
      rangeFrom: '200,000',
      rangeTo: t('common_to_up'),
      multiplier: '1.20',
      color: 'bg-[#2878ff]',
    },
  ]

  return (
    <section id='reward' className='py-5xl sm:py-8xl'>
      <Col className='gap-3xl text-center'>
        <Col className='gap-md'>
          <Typography
            variant='h2'
            size='lg'
            weight='bold'
            className='text-center text-neutral-main'
          >
            {t('square_token_reward_title')}
          </Typography>
          <Typography
            variant='p'
            size='md'
            className='text-center text-neutral-main'
          >
            {t('square_token_reward_desc')}
          </Typography>
        </Col>
        <Col className='gap-md'>
          <Typography
            variant='h3'
            size='lg'
            weight='bold'
            className='text-neutral-main'
          >
            {t('square_token_time_decrease_title')}
          </Typography>
          <Typography variant='p' size='sm' className='text-neutral-main'>
            {tRich.rich('square_token_time_decrease_desc', {
              b: (chunks) => <b>{chunks}</b>,
            })}
          </Typography>
        </Col>
        <Col className='gap-md'>
          <Typography
            variant='h3'
            size='lg'
            weight='bold'
            className='text-neutral-main'
          >
            {t('square_token_token_increase_title')}
          </Typography>
          <Typography variant='p' size='sm' className='text-neutral-main'>
            {t('square_token_token_increase_desc')}
          </Typography>
        </Col>

        {/* Level Table */}

        <Col className='gap-md'>
          <div className='overflow-x-auto'>
            <table className='w-full sm:w-[480px] mx-auto'>
              <thead>
                <tr>
                  <th className='text-center py-md px-md text-xs font-regular text-neutral-surface-80'>
                    {t('square_token_level')}
                  </th>
                  <th className='text-right py-md px-md text-xs font-regular text-neutral-surface-80'>
                    {t('square_token_amount')}
                  </th>
                  <th className='text-right py-md px-md text-xs font-regular text-neutral-surface-80'>
                    {t('square_token_multiplier')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {levels.map((level, index) => (
                  <tr key={index}>
                    <td className='py-2xs sm:py-xs px-md text-center text-xs font-regular'>
                      <Badge
                        className={`bg-gradient-to-r ${level.color} rounded-full w-[64px] from-[#FFFFFF00] to-[#FFFFFF] text-[#00000099]`}
                      >
                        {t(
                          `square_token_level_${level.name}` as keyof typeof t,
                        )}
                      </Badge>
                    </td>
                    <td className='py-2xs sm:py-xs px-md text-right'>
                      <Typography size='sm' className='text-neutral-main'>
                        {level.rangeFrom}
                        {/* {' '}
                        {level.name !== 'expert' && t('common_to')}{' '}
                        {level.rangeTo} */}
                      </Typography>
                    </td>
                    <td className='py-2xs sm:py-xs px-md text-right'>
                      <Badge
                        color='custom'
                        variant='custom'
                        className={cn(
                          'bg-multiply-gradient',
                          'px-xs flex items-center rounded-full !font-bold text-black-100',
                          'text-xs',
                        )}
                      >
                        <bdi className='font-sans font-bold'>
                          {level.multiplier} ×
                        </bdi>

                        <Icon name='Fire' size='sm' />
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Col>
      </Col>
    </section>
  )
}
